/**
 * action types
 */
export const ADD_TO_CART = 'ADD_TO_CART';
export const ADD_TO_CART_QUANTITY = 'ADD_TO_CART_QUANTITY';
export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST';
export const REMOVE_FROM_WISHLIST = 'REMOVE_FROM_WISHLIST';
export const MOVE_WISHLISTITEM_TO_CART = 'MOVE_WISHLISTITEM_TO_CART';
export const FINAL_PAYMENT = 'FINAL_PAYMENT';
export const HIDE_ALERT = 'HIDE_ALERT';
export const SHOW_ALERT = 'SHOW_ALERT';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const UPDATE_PRODUCT_QUANTITY = 'UPDATE_PRODUCT_QUANTITY';
export const CHANGE_CURRENCY = 'CHANGE_CURRENCY';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const RTL_LAYOUT = "RTL_LAYOUT";
export const COLLAPSED_SIDEBAR = 'COLLAPSED_SIDEBAR';
export const DELETE_USER = 'DELETE_USER';
export const ADD_NEW_USER = 'ADD_NEW_USER';
export const DARK_MODE = 'DARK_MODE';

export const ORDER_CODE = 'ORDER_CODE';



export const INITIALIZE_CART = 'INITIALIZE_CART';
export const UPDATE_SHIPPING_COST = 'UPDATE_SHIPPING_COST';
export const LOGIN = 'LOGIN';